import type {
  GenerateAccountStatementPdfMutation,
  GenerateAccountStatementPdfMutationVariables,
} from "@/__generated__/graphql";
import { GenerateAccountStatementPdfDocument } from "@/__generated__/graphql";
import { generatePDFUrl } from "@/components/shared/pdf-viewer";

import { createRequestFactory } from "@/lib/request-factory";

export const useGenerateInvoiceAccountStatementPdfStore = createRequestFactory<
  GenerateAccountStatementPdfMutation,
  string,
  GenerateAccountStatementPdfMutationVariables
>({
  method: "mutation",
  graphqlDocument: GenerateAccountStatementPdfDocument,
  transformFunction(data) {
    if (data.generateAccountStatementPdf?.fileString) {
      return generatePDFUrl(data.generateAccountStatementPdf.fileString);
    }
    throw new Error("Unable to generate PDF");
  },
});
